"use client";

import { useState } from "react";
import { useLanguage } from "@/i18n/LanguageContext";

const faqsEn = [
  {
    q: "Can I combine impact windows and shutters?",
    a: "Yes — impact windows on living areas and shutters on rear bedrooms or secondary openings. Insurance discounts still apply to all impact-rated openings, and shutters add backup protection to non-impact areas.",
  },
  {
    q: "Do shutters meet HVHZ code?",
    a: "Yes, if they are NOA-approved and installed by a licensed contractor. Roll-up and accordion shutters from approved manufacturers like Atlas, RollSafe, and Armor Screen pass Miami-Dade code when properly anchored.",
  },
  {
    q: "Which is faster to install?",
    a: "Shutters are faster (1–3 days for a typical home). Impact windows take 5–8 business days but require far less ongoing maintenance over the property lifetime.",
  },
  {
    q: "What about hurricane fabric panels?",
    a: "Fabric panels are the lowest-cost option but require manual deployment and storage. They are acceptable for HVHZ if NOA-approved, but insurers and buyers rate them below permanent shutters or impact windows.",
  },
];

const faqsEs = [
  {
    q: "¿Puedo combinar ventanas de impacto y persianas?",
    a: "Sí — ventanas de impacto en áreas de estar y persianas en habitaciones traseras o aberturas secundarias. Los descuentos de seguro aún aplican a todas las aberturas con clasificación de impacto, y las persianas añaden protección adicional a las áreas sin impacto.",
  },
  {
    q: "¿Las persianas cumplen el código HVHZ?",
    a: "Sí, si tienen aprobación NOA y son instaladas por un contratista con licencia. Las persianas enrollables y de acordeón de fabricantes aprobados como Atlas, RollSafe y Armor Screen cumplen el código de Miami-Dade cuando están correctamente ancladas.",
  },
  {
    q: "¿Cuál es más rápido de instalar?",
    a: "Las persianas son más rápidas (1–3 días para una casa típica). Las ventanas de impacto toman 5–8 días hábiles pero requieren mucho menos mantenimiento continuo durante la vida útil de la propiedad.",
  },
  {
    q: "¿Qué hay de los paneles de tela para huracanes?",
    a: "Los paneles de tela son la opción de menor costo pero requieren despliegue manual y almacenamiento. Son aceptables para HVHZ si tienen aprobación NOA, pero los aseguradores y compradores los valoran por debajo de persianas permanentes o ventanas de impacto.",
  },
];

export default function FaqAccordion() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const { currentLang, t } = useLanguage();
  const isEs = currentLang === "es";
  const faqs = isEs ? faqsEs : faqsEn;

  return (
    <section className="py-12">
      <h2 className="text-3xl font-bold text-[#064e3b] mb-6">
        {t("blog.shutters.faqHeading")}
      </h2>
      <div className="space-y-3">
        {faqs.map((faq, i) => {
          const isOpen = openIndex === i;
          return (
            <div key={i} className="border border-[#064e3b]/10 rounded-lg overflow-hidden">
              <button
                onClick={() => setOpenIndex(isOpen ? null : i)}
                className="w-full flex items-center justify-between px-5 py-4 text-left bg-white hover:bg-[#fefce8] transition"
              >
                <span className="font-semibold text-[#064e3b] text-sm">{faq.q}</span>
                <span className={`w-6 h-6 flex items-center justify-center rounded-full bg-[#fbbf24] text-[#064e3b] text-xs font-bold transition-transform ${isOpen ? "rotate-180" : ""}`}>
                  &#9662;
                </span>
              </button>
              {isOpen && (
                <div className="px-5 pb-4 text-sm text-gray-600 leading-relaxed bg-white">
                  {faq.a}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </section>
  );
}